import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { FacilityManager } from "../models/facilitymanager"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FacilityManagerService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'facilitymanager/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllFacilityManager(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<FacilityManager>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllFacilityManager?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewFacilityManager(FacilityManagerID?: string): Observable<Array<FacilityManager>> {
    return this.httpService.get(this.apiEndpoint + 'viewFacilityManager/' + (FacilityManagerID ? FacilityManagerID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveFacilityManager(facilitymanagers: FacilityManager): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveFacilityManager/', facilitymanagers).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkEmail(Emailid?: string, FacilityManagerId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&FacilityManagerId=' + (FacilityManagerId ? FacilityManagerId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deleteFacilityManager(FacilityManagerID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteFacilityManager/' + (FacilityManagerID ? FacilityManagerID : '00000000-0000-0000-0000-000000000000'), FacilityManagerID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(FacilityManagerName?: string,FacilityManagerId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?FacilityManagerName=' + (FacilityManagerName ? FacilityManagerName : '')+ '&FacilityManagerId=' + (FacilityManagerId ? FacilityManagerId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
